import api from './api'; 

const salvarMetasEmLote = async (metasArray) => {
    const response = await api.post('/metas-venda/lote', { metas: metasArray });
    return response.data;
};

export default {
    salvarMetasEmLote
};